
import truncate from '@shared/helpers/web3/truncate';

import type * as Dialog from '@radix-ui/react-dialog';
import { ConfirmDialog } from '@ui/uikit/components/common/Dialog';

type Props = Dialog.DialogProps & {
  onConfirm?: () => void;
  isHumanityVerification: boolean;
  network: string;
  address: string;
};

export const ConfirmDeleteModal = ({
  onConfirm,
  isHumanityVerification,
  address,
  network,
  ...props
}: Props) => {
  return (
    <ConfirmDialog
      onConfirm={onConfirm}
      title={isHumanityVerification ? 'Warning' : 'Are you sure you want to remove that wallet'}
      description={
        <div>
          {isHumanityVerification ? (
            <div>
              {`Once removed, this wallet (${truncate(
                address,
              )}) cannot be assigned to another account if it has a Gitcoin score.`}
              <br />
              <br />
              Before removing the wallet, make sure that an email or Telegram is connected to your
              account.
            </div>
          ) : (
            `${network}: ${address}`
          )}
        </div>
      }
      {...props}
    />
  );
};
